import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled.div`
  height: 100%;
`

export const Topbar = styled.div`
  display: flex;
  align-items: center;
  padding: 13px 30px 13px 50px;
  background-color: #fafafa;
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #e9e9e9;
`

export const ReadGridContainer = styled.div`
  height: calc(100% - 73px);
  background-color: #f6f6f6;
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`

export const FlexDiv = styled.div`
  flex: 1;
  flex-direction: column;
  align-items: center;
`

export const title = css`
  text-transform: none;
`

export const buttonMargin = css`
  margin-left: 12px;
`
